import React, { useState } from 'react';
import './Login.css';

function Login({ onLogin }) {
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (password === process.env.REACT_APP_PASSWORD) {
      onLogin();
    } else {
      alert('密码错误');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit}>
        <h2>来者何人</h2>
        <label>
          访问密码:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
        </label>
        <button type="submit">登录</button>
      </form>
    </div>
  );
}

export default Login;
